// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carousel-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    box-sizing: border-box;
}

.carousel-container {
    display: flex;
    gap: 1rem;
    overflow-x: auto;
    scroll-behavior: smooth;
    flex-wrap: nowrap;
    width: 100%;
    scrollbar-width: none;
}

.carousel-container::-webkit-scrollbar {
    display: none;
    /* Chrome, Safari */
}

.card-container {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc((100% - 2rem) / 3);
    /* height: 250px; */
    background-color: #FFFFFF;
    padding: 20px;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
}

/* =============== */


@media (max-width: 1024px) {
    .card-container {
        flex-grow: 0;
        flex-shrink: 0;
        flex-basis: calc((100% - 2rem) / 2);
    }
}

@media (max-width: 600px) {
    .card-container {
        flex-grow: 0;
        flex-shrink: 0;
        flex-basis: calc((100%));
    }
}

/* =============== */


.arrow-btn {
    background: transparent;
    border: none;
}


.dots-container {
    display: flex;
    justify-content: center;
    gap: 8px;
    margin-top: 1rem;
}

.dot {
    width: 10px;
    height: 10px;
    background: #999;
    border-radius: 50%;
    transition: 0.3s;
}

.dot.active {
    background: #edc35a;
}`, "",{"version":3,"sources":["webpack://./src/components/CarouselView/Carousel.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;IACjB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAiC;IAAjC,cAAiC;IAAjC,mCAAiC;IACjC,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,sBAAsB;AAC1B;;AAEA,oBAAoB;;;AAGpB;IACI;QACI,YAAiC;QAAjC,cAAiC;QAAjC,mCAAiC;IACrC;AACJ;;AAEA;IACI;QACI,YAAsB;QAAtB,cAAsB;QAAtB,wBAAsB;IAC1B;AACJ;;AAEA,oBAAoB;;;AAGpB;IACI,uBAAuB;IACvB,YAAY;AAChB;;;AAGA;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".carousel-wrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    box-sizing: border-box;\n}\n\n.carousel-container {\n    display: flex;\n    gap: 1rem;\n    overflow-x: auto;\n    scroll-behavior: smooth;\n    flex-wrap: nowrap;\n    width: 100%;\n    scrollbar-width: none;\n}\n\n.carousel-container::-webkit-scrollbar {\n    display: none;\n    /* Chrome, Safari */\n}\n\n.card-container {\n    flex: 0 0 calc((100% - 2rem) / 3);\n    /* height: 250px; */\n    background-color: #FFFFFF;\n    padding: 20px;\n    border-radius: 20px;\n    display: flex;\n    flex-direction: column;\n}\n\n/* =============== */\n\n\n@media (max-width: 1024px) {\n    .card-container {\n        flex: 0 0 calc((100% - 2rem) / 2);\n    }\n}\n\n@media (max-width: 600px) {\n    .card-container {\n        flex: 0 0 calc((100%));\n    }\n}\n\n/* =============== */\n\n\n.arrow-btn {\n    background: transparent;\n    border: none;\n}\n\n\n.dots-container {\n    display: flex;\n    justify-content: center;\n    gap: 8px;\n    margin-top: 1rem;\n}\n\n.dot {\n    width: 10px;\n    height: 10px;\n    background: #999;\n    border-radius: 50%;\n    transition: 0.3s;\n}\n\n.dot.active {\n    background: #edc35a;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
